import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqData } from '@/mocks/faq';

export default function FAQSection() {
  const { t } = useTranslation('home');
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-main">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block text-xs font-medium text-secondary-600 uppercase tracking-wider mb-2">
              FAQ
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('faq.title')}
            </h2>
          </div>

          <div className="space-y-3">
            {faqData.map((faq, i) => (
              <div
                key={faq.id}
                className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="flex items-center justify-between w-full px-4 md:px-6 py-4 text-left"
                >
                  <span className="font-medium text-sm md:text-base text-foreground-900 pr-4">
                    {t(faq.questionKey)}
                  </span>
                  <i
                    className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-lg text-foreground-400 flex-shrink-0 transition-transform`}
                  />
                </button>
                {openIndex === i && (
                  <div className="px-4 md:px-6 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {t(faq.answerKey)}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}